import * as types from "./types";

const prepaymentState = {
  loading: false,
  invoice: null
};

export default (state = prepaymentState, action) => {
  switch (action.type) {
    case types.SET_LOADING: {
      return {
        ...state,
        loading: action.payload
      };
    }
    case types.CREATE_PRE_PAYMENT_SUCCESS: {
      return {
        ...state,
        invoice: action.payload
      };
    }
    default:
      return state;
  }
};
